import classNames from "classnames";
import { formatDate } from "helpers/common_helpers";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { downloadSubscriptionInvoice, getAllPlans, getBillingHistory, myCurrentSubscription } from "store/actions/subscriptionSlice";
import { useTranslation } from "react-i18next";
import logo from "../../../assets/images/icons/checked.svg";
import { capitalizeFirstLetter, CurrencySymbol, formatPlanType, getMinMaxDate } from "components/common/Utils";
import { Link, useNavigate } from "react-router-dom";
import Paginations from "components/common/Paginations";
import { Badge, Col, Row, Table } from "react-bootstrap";
import Filters from "components/common/Filters";
import NoDataFound from "components/common/NoDataFound";
import Spinners from "components/common/Spinners";
import { transactionsStatus } from "components/constants/StatusKeys";
import arrowFilter from "assets/images/icons/arrowFilter.svg";
import { setSortedTransactions } from "store/reducers/subscriptionReducer";
import MyPlanInfo from "./MyPlanInfo";
import { showAlert } from "store/reducers/alertReducer";
import { getCompanyInfo } from "store/actions/authSlice";
import ButtonLoader from "components/common/ButtonLoader";


function MyPlan() {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [planType, setPlanType] = useState(null);
    const [selectedPlan, setselectedPlan] = useState(null);
    const [selectedTab, setSelectedTab] = useState(1);
    const [show, setShow] = useState(false);
    const [sortField, setSortField] = useState("");
    const [sortDirection, setSortDirection] = useState("asc");
    const [selectedId, setSelectedId] = useState(null);




    document.title = t("Overview Dashboard | Work Space");

    const {
        loading,
        isLoading,
        allPlans,
        mySubscriptionDetails,
        perPage,
        totalCount,
        totalPages,
        currentPage,
        transactions,

    } = useSelector(
        (state) => state.Subscriptions
    );
    const {
        orgnisationDetails
    } = useSelector(
        (state) => state.auth
    );
    const monthlyPlan = allPlans?.find(
        (plan) => plan.billingCycle === "MONTHLY"
    );
    useEffect(() => {
        dispatch(getAllPlans());
        dispatch(getCompanyInfo());
        dispatch(myCurrentSubscription()).then((action) => { });
        getAllData();
    }, []);
    const getAllData = (page, action) => {
        const { actionType } = action || {}; // SEARCH, RESET, RESET_KEYWORD
        const isReset = actionType === "RESET";

        const payload = {
            perPage,
            pageNo: page || 1,
            status: -1,
            orderBy: -1,
            keyword: ["RESET", "RESET_KEYWORD"].includes(actionType)
                ? ""
                : keyword || "",
            dateRange: isReset ? {} : getMinMaxDate(dates)
        };
        dispatch(getBillingHistory(payload));
    };
    const [keyword, setKeyword] = useState("");
    const [dates, setDates] = useState([]);
    useEffect(() => {
        if (mySubscriptionDetails && !loading) {
            const { isCustom, isTrial } = mySubscriptionDetails || {};
        }
    }, [mySubscriptionDetails]);


    const handleUpdatePlan = () => {
        const { isTrial, planId } = mySubscriptionDetails || {};

        // IF HAVE FREE_TRIAL THEN REDIRECT TO PLAN PAGE:
        if (isTrial) {
            navigate(`/subscription?selectedPlan=${planId.name}`);
        } else {
            handleShow(true);
        }
    };
    const handleShow = () => setShow(true);
    const checkCompanyDetails = (callback) => {
        if (
            !orgnisationDetails?.companyDetails?.countryId ||
            !orgnisationDetails?.companyDetails?.commercialNumber ||
            !orgnisationDetails?.companyDetails?.vatNumber
        ) {
            dispatch(
                showAlert({
                    text: t("Please complete your organization information first."),
                    type: "error",
                })
            );
            navigate("/orgnisation-details");
            return;
        }
        callback(); // proceed if valid
    };



    // const planAmount = selectedPlan.price;
    const handleReset = () => {
        setKeyword("");
        setDates([]);
        getAllData(1, { actionType: "RESET" });
    };
    const SortableHeader = ({ field, label }) => (
        <div className="c_p" onClick={() => handleSort(field)}>
            <img src={arrowFilter} width={16} height={16} alt="arrow" />
            {t(label)}
        </div>
    );
    const handleSort = (field) => {
        // Only sort specific fields
        const sortableFields = ["createdAt", "splitPayments.total"];
        if (!sortableFields.includes(field)) return;

        // Toggle direction if clicking the same field
        const newDirection =
            sortField === field && sortDirection === "asc" ? "desc" : "asc";

        setSortField(field);
        setSortDirection(newDirection);

        // Create a sorted copy of the coupons array
        const sortedData = [...transactions].sort((a, b) => {
            // Handle date fields
            if (field === "createdAt") {
                if (!a[field]) return 1;
                if (!b[field]) return -1;

                const dateA = new Date(a[field]).getTime();
                const dateB = new Date(b[field]).getTime();
                return newDirection === "asc" ? dateA - dateB : dateB - dateA;
            }

            // Handle nested fields
            if (field === "splitPayments.total") {
                const [parent, child] = field.split(".");
                const valueA = Number(a[parent]?.[child]) || 0;
                const valueB = Number(b[parent]?.[child]) || 0;
                return newDirection === "asc" ? valueA - valueB : valueB - valueA;
            }

            return 0;
        });

        dispatch(setSortedTransactions(sortedData));
    };
    const [isInvoiceDownload, setIsInvoiceDownload] = useState(false);

    const handleInvoiceDownload = (id) => {
        setIsInvoiceDownload(true);
        dispatch(downloadSubscriptionInvoice(id))
            .then((action) => {
                const { statusCode, success, message, data } = action?.payload || {};
                if (statusCode === 200 && success) {
                    dispatch(showAlert({ text: message, type: "success" }));
                    setSelectedId(null);
                    data && window.open(data, "_blank", "noopener,noreferrer");
                } else {
                    dispatch(showAlert({ text: message, type: "error" }));
                }
            })
            .catch((err) => { })
            .finally(() => {
                setIsInvoiceDownload(false);
            });
    };



    return (
        <div className="my_plan_page common_page">
            <div className="container">
                <div className="w-100 row">
                    <div className="g_between gap-2 gap-sm-3">
                        <h1 className="main_title">{t("My Plan")}</h1>
                    </div>
                </div>
                <div className="common_wrapper">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="tab_btns">
                                <button
                                    className={selectedTab === 1 ? "active" : ""}
                                    onClick={() => setSelectedTab(1)}
                                >
                                    {t("Plan Info")}
                                </button>
                                <button
                                    className={selectedTab === 2 ? "active" : ""}
                                    onClick={() => setSelectedTab(2)}
                                >
                                    {t("Billing History")}
                                </button>
                            </div>
                        </div>
                    </div>
                    {
                        selectedTab === 1 &&
                        <MyPlanInfo />
                    }
                    {selectedTab === 2 ? (

                        <Row>
                            <div className="page-content common_page">
                                <div className="">
                                    <Filters
                                        keyword={keyword}
                                        setKeyword={setKeyword}
                                        onSearch={getAllData}
                                        onReset={handleReset}
                                        dates={dates}
                                        setDates={setDates}
                                    />{" "}
                                    <Row>
                                        <Col lg={12}>
                                            {loading ? (
                                                <Spinners />
                                            ) : transactions.length === 0 ? (
                                                <NoDataFound />
                                            ) : (
                                                <div className="common_table_style mt_20">
                                                    <Table>
                                                        <thead className="t_head">
                                                            <tr>
                                                                <th>{t("Subscription Plan")}</th>
                                                                <th>{t("Start Date")}</th>
                                                                <th>{t("End Date")}</th>
                                                                <th>
                                                                    <SortableHeader
                                                                        field="splitPayments.total"
                                                                        label="Amount"
                                                                    />
                                                                </th>
                                                                <th>{t("Status")}</th>
                                                                {/* <th>{t("Granted By")}</th>
                                                                <th>{t("Refund Info")}</th>
                                                                <th>{t("Addon Info")}</th> */}
                                                                <th>{t("Invoice")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {transactions?.map((item, index) => (
                                                                <tr key={item._id}>
                                                                    <td>
                                                                        <p>
                                                                            {t(capitalizeFirstLetter(item?.billingCycle))}
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="w_fit_content">
                                                                            {formatDate(
                                                                                item?.billingInfo?.startAt
                                                                            )}
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="w_fit_content">
                                                                            {formatDate(item?.billingInfo?.endAt)}
                                                                        </p>
                                                                    </td>
                                                                    <td className="ltr">
                                                                        <CurrencySymbol
                                                                            width="10"
                                                                            height="11"
                                                                            color={"#384459"}
                                                                        />
                                                                        {item?.splitPayments?.gatewayAmount}
                                                                    </td>
                                                                    <td>
                                                                        {item?.gatewayStatus !==
                                                                            "GRANT_ACCESS" &&
                                                                            item?.gatewayStatus !==
                                                                            "FREE_TRIAL" && (
                                                                                <p
                                                                                    className={`subscriptions_status` +
                                                                                        transactionsStatus?.find(
                                                                                            (option) =>
                                                                                                option?.value ===
                                                                                                item?.paymentStatus
                                                                                        )?.className
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        transactionsStatus?.find(
                                                                                            (option) =>
                                                                                                option?.value ===
                                                                                                item?.paymentStatus
                                                                                        )?.name
                                                                                    }
                                                                                </p>
                                                                            )}
                                                                        {(item?.gatewayStatus ===
                                                                            "GRANT_ACCESS" ||
                                                                            item?.gatewayStatus ===
                                                                            "FREE_TRIAL") && (
                                                                                <p
                                                                                    className={`subscriptions_status paid`}
                                                                                >
                                                                                    <Badge className="bg-success">
                                                                                    {t("Success")}
                                                                                    </Badge>
                                                                                </p>
                                                                            )}
                                                                    </td>
                                                                    {/* <td>
                                                                        <Link
                                                                            to={`/users/user-information?id=${item?.grantedBy?._id}`}
                                                                            className={`text_primary ${item?.grantedBy?.name
                                                                                ? "text-decoration-underline"
                                                                                : "text-decoration-none"
                                                                                }`}
                                                                        >
                                                                            {item?.grantedBy?.name || "-"}
                                                                        </Link>
                                                                    </td> */}
                                                                    {
                                                                        /**
                                                                         <td>
                                                                        {item?.paymentStatus === 3 ? (
                                                                            <button
                                                                                className="transparent_btn text_primary text-decoration-underline"
                                                                                type="button"
                                                                            // onClick={() => {
                                                                            //     setShowRefundModal(true);
                                                                            //     setModalType("REFUND_INFO");
                                                                            //     setSelectedItem(item?.refundInfo);
                                                                            // }}
                                                                            >
                                                                                View Details
                                                                            </button>
                                                                        ) : null}
                                                                    </td>
                                                                         */
                                                                    }
                                                                    {/* <td>
                                                                        {item?.addonDetails?.isSelected ? (
                                                                            <button
                                                                                className="transparent_btn text_primary text-decoration-underline"
                                                                                type="button"
                                                                            // onClick={() => {
                                                                            //     setShowRefundModal(true);
                                                                            //     setModalType("ADDON_INFO");
                                                                            //     setSelectedItem(
                                                                            //         item?.addonDetails
                                                                            //     );
                                                                            // }}
                                                                            >
                                                                                View Details
                                                                            </button>
                                                                        ) : null}
                                                                    </td> */}
                                                                    {<td>
                                                                        {item?.invoiceUrl && mySubscriptionDetails.wasTrial && item?.paymentStatus === 1 && (
                                                                            <button
                                                                                className="main_btn"
                                                                                onClick={() =>
                                                                                    checkCompanyDetails(() => {
                                                                                        window.open(
                                                                                            item.invoiceUrl,
                                                                                            "_blank"
                                                                                        );
                                                                                    })
                                                                                }
                                                                            >
                                                                                {t("Invoice")}
                                                                            </button>
                                                                        )}
                                                                        {!item?.invoiceUrl && mySubscriptionDetails.wasTrial && item?.paymentStatus === 1 && (
                                                                            
                                                                                <button
                                                                                    className="main_btn g_center gap-2"
                                                                                    onClick={() =>
                                                                                        checkCompanyDetails(() => {
                                                                                            handleInvoiceDownload(
                                                                                                item._id
                                                                                            );
                                                                                            setSelectedId(item._id);
                                                                                        })
                                                                                    }
                                                                                    disabled={
                                                                                        isInvoiceDownload &&
                                                                                        selectedId === item?._id
                                                                                    }
                                                                                >

                                                                                    {console.log("Here Am I")}
                                                                            
                                                                                    {t("Invoice")}
                                                                                    {isInvoiceDownload &&
                                                                                        selectedId === item?._id && (
                                                                                            <ButtonLoader />
                                                                                        )}
                                                                                </button>
                                                                            )}
                                                                    </td>}
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                                {!loading && (
                                    <Paginations
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        onPageChange={(page) => {
                                            getAllData(page);
                                        }}
                                        totalCount={totalCount}
                                    />
                                )}
                            </div>
                        </Row>
                    ) : null}

                </div>
            </div>
        </div>
    );
}

export default MyPlan;
